angular.module('dnecom')
    .directive('attributeValuesUiSelect', ["$http", "ProductAttributesUtils", function ($http, ProductAttributesUtils) {
        return {
            require: 'uiSelect',

            link: function(scope, element, attrs, $select) {
                var storeId = attrs.storeId;
                var productId = attrs.productId;
                var attributeId = attrs.attributeId;
                var isSingleAttr = attrs.isSingleAttr;
                var removingAttributeValue = {};

                var tag = function (value) {
                    var exists = false;

                    _.each($select.selected, function (selected) {
                        if (selected.value.toLowerCase() == value.toLowerCase()) {
                            exists = true;
                        }
                    });

                    return exists ? false : { value: value, isTag: true };
                };

                $select.tagging = {
                    isActivated: true,
                    fct: tag
                };

                $select.onSelectCallback = function ($scope, data) {
                    scope.setUpdatingAttribute(attributeId, true);

                    ProductAttributesUtils.addValue(storeId, productId, attributeId, { value: (data.$item || {}).value, name: null }, function (response) {
                        angular.extend(data.$item, response.data.value);
                        scope.$emit('avuis:added', data.$item);
                        scope.setUpdatingAttribute(attributeId, false);
                    }, function (error) {
                        scope.$emit('avuis:added:failed', { item: data.$item, error: error.data, attributeId: attributeId });
                        scope.setUpdatingAttribute(attributeId, false);
                    });
                };

                if (!isSingleAttr) {
                    $select.onRemoveCallback = function ($scope, data) {
                        $scope.hideAttributeImagesSelector();
                        scope.setUpdatingAttribute(attributeId, true);

                        ProductAttributesUtils.removeValue(storeId, productId, attributeId, data.$item, function (response) {
                            if (data.$item) {
                                removingAttributeValue[data.$item.id] = false;
                            }

                            scope.$emit('avuis:removed', data.$item);
                            scope.setUpdatingAttribute(attributeId, false);
                        }, function () {
                            scope.$emit('avuis:removed:failed', data.$item);

                            if (data.$item) {
                                removingAttributeValue[data.$item.id] = false;
                            }

                            scope.setUpdatingAttribute(attributeId, false);
                        });
                    };
                }

                scope.$on('uis:activate', function () {
                    scope.$emit('avuis:activate', $select, attributeId);
                });
            }
        };
    }]);